import { useTranslation } from 'react-i18next';
import SimpleSelectFormInput, { SimpleSelectFormInputProps } from './SimpleSelectFormInput';

export type JournalGroupSelectFormInputProps = Omit<
  SimpleSelectFormInputProps,
  'options' | 'value'
> & {
  countryCode: string;
};

const JournalGroupSelectFormInput = ({
  disabled,
  countryCode,
  ...rest
}: JournalGroupSelectFormInputProps) => {
  const { t } = useTranslation();

  const options = [
    { id: 'SALES', description: t('reprocess.journalGroups.SALES') },
    { id: 'COLLECTIONS', description: t('reprocess.journalGroups.COLLECTIONS') },
  ];

  return (
    <SimpleSelectFormInput
      {...rest}
      label={t('reprocess.labels.journalGroup')}
      options={options}
      disabled={disabled}
      loading={false}
    />
  );
};

export default JournalGroupSelectFormInput;
